// @flow

import { isEmpty } from 'lodash';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useWindowDimensions, View } from 'react-native';
import { APIContext, getUser } from 'speed-js-react';
import type { Account as AccountType } from './types';
import styles from './styles';
import Account from './Account';

type Props = {
    onAccountSelect: (account: AccountType) => void,
    allAccounts: AccountType[],
    currentAccount: AccountType,
}

export const useLoadAccounts = (): [
    boolean, AccountType[], AccountType | null, (acc: AccountType) => void
] => {
    const user = useSelector(getUser);
    const { apiClient } = React.useContext(APIContext);

    const [loaded, setLoaded] = React.useState(false);
    const [allAccounts, setAllAccounts] = React.useState([]);
    const [currentAccount, setCurrentAccount] = React.useState(null);

    const setCurrent = React.useCallback((account: AccountType) => {
        if (!isEmpty(account)) {
            localStorage.setItem('account', account.uuid);
            setCurrentAccount(account);
        } else {
            localStorage.removeItem('account');
        }
    }, []);

    React.useEffect(() => {
        if (user) {
            apiClient.resources.currentAccounts.list().then((response) => {
                const accounts = response.results;
                setAllAccounts(accounts);
                const _c = localStorage.getItem('account');
                let current = null;
                if (!_c && accounts.length) {
                    // eslint-disable-next-line prefer-destructuring
                    current = accounts[0];
                } else if (accounts.length === 1) {
                    // eslint-disable-next-line prefer-destructuring
                    current = accounts[0];
                } else {
                    current = accounts.find((a) => (a.uuid === _c));
                }
                if (!current && accounts.length) {
                    // eslint-disable-next-line prefer-destructuring
                    current = accounts[0];
                }
                setCurrent(current);

                setLoaded(true);
            });
        }
    }, [user, apiClient, setCurrent]);

    return [loaded, allAccounts, currentAccount, setCurrent];
};

const AccountSelector = ({ onAccountSelect, allAccounts, currentAccount }: Props) => {
    const { width } = useWindowDimensions();

    return (
        <View style={width > 600 ? styles.accountsListWrapper : styles.accountsListWrapperMobile}>
            {
                allAccounts.map((acc) => (
                    <Account
                        key={acc.uuid}
                        account={acc}
                        active={currentAccount && acc.uuid === currentAccount.uuid}
                        onPress={() => onAccountSelect(acc)}
                    />
                ))
            }
        </View>
    );
};

export default AccountSelector;
